import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'inputWrapper', 'successMessage']
  static classes = ['passive', 'success', 'failure']
  static values = {
    baseUrl: String
  }

  async subscribe () {
    this.#resetClasses()
    const url = `${this.baseUrlValue}/index.php?rest_route=/bespoke/v1/subscribers`

    const body = {
      email: this.inputTarget.value
    }

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })

    this.inputWrapperTarget.classList.remove(...this.passiveClasses)

    if (response.ok) {
      this.inputWrapperTarget.classList.add(...this.successClasses)
      this.successMessageTarget.classList.remove('hidden')
    } else {
      this.inputWrapperTarget.classList.add(...this.failureClasses)
    }
  }

  #resetClasses () {
    this.successMessageTarget.classList.add('hidden')
    this.inputWrapperTarget.classList.remove(...this.successClasses)
    this.inputWrapperTarget.classList.remove(...this.failureClasses)
    this.inputWrapperTarget.classList.add(...this.passiveClasses)
  }
}
